import { inject, Injectable } from '@angular/core';
import { StateContext } from '@ngxs/store';
import { TableStateModel } from '../table.state.model';
import { Pagination } from '@core/models/pagination.model';
import { TableActions } from '../table.actions';
import { NotificationService } from '@core/services/notification.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationLogsHandler {
  constructor() {}
  notificationService = inject(NotificationService);

  handleNotificationLogsLoad(
    ctx: StateContext<TableStateModel>,
    params: Pagination
  ) {
    this.notificationService.getNotifications({ ...params }).subscribe({
      next: (response) => {
        ctx.dispatch(
          new TableActions.LoadTableDataSuccess({
            tableKey: 'notificationLogs',
            data: response.data?.data,
            totalCount: response.data?.total_count,
          })
        );
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'notificationLogs',
            error: error.message,
          })
        );
      },
    });
  }

  filterNotificationLogList(
    ctx: StateContext<TableStateModel>,
    action: TableActions.FilterNotificationLog
  ) {
    return this.notificationService
      .getNotifications(undefined, action.payload.filter)
      .subscribe({
        next: (response) => {
          ctx.dispatch(
            new TableActions.LoadTableDataSuccess({
              tableKey: 'notificationLogs',
              data: response.data?.data,
              totalCount: response.data?.total_count,
            })
          );
        },
        error: (error) => {
          ctx.dispatch(
            new TableActions.LoadTableDataFailure({
              tableKey: 'notificationLogs',
              error: error.message,
            })
          );
        },
      });
  }

  handleNotificationUsersLoad(ctx: StateContext<TableStateModel>, params: Pagination) {
    this.notificationService
      .getNotificationEnabledAccounts({ skip: params.skip ?? 0, take: params.size ?? 10 })
      .subscribe({
        next: (response) => {
          ctx.dispatch(
            new TableActions.LoadTableDataSuccess({
              tableKey: 'notificationUsers',
              data: response.data?.data ?? [],
              totalCount: response.data?.total_count ?? 0,
            })
          );
        },
        error: (error) => {
          ctx.dispatch(
            new TableActions.LoadTableDataFailure({
              tableKey: 'notificationUsers',
              error: error.message,
            })
          );
        },
      });
  }

  filterNotificationUsersList(
    ctx: StateContext<TableStateModel>,
    action: TableActions.FilterNotificationUsersList
  ) {
    const params = new URLSearchParams(action.payload.filter);
    return this.notificationService
      .getNotificationEnabledAccounts({
        search_text: params.get('search_text') || undefined,
        account_type: params.get('account_type') || undefined,
        skip: Number(params.get('skip') ?? 0),
        take: Number(params.get('take') ?? 10),
      })
      .subscribe({
        next: (response) => {
          ctx.dispatch(
            new TableActions.LoadTableDataSuccess({
              tableKey: 'notificationUsers',
              data: response.data?.data ?? [],
              totalCount: response.data?.total_count ?? 0,
            })
          );
        },
        error: (error) => {
          ctx.dispatch(
            new TableActions.LoadTableDataFailure({
              tableKey: 'notificationUsers',
              error: error.message,
            })
          );
        },
      });
  }
}
